import { HocElDivider, ExitIcon, UserVipIcon, SizedBox, Uid } from 'ui-components'
import UserMenuComp from '@/components/UserMenuComp.tsx'
import useUserCommon from '@/hooks/use-user-common.ts'
import { CopyText } from '@/components/Copy.tsx'
import { useI18n } from 'i18n-utils'
import './MobileUserMenu.scss'

export default defineComponent({
  props: {
    onClose: Function as PropType<() => void>,
  },
  setup(props) {
    const { t } = useI18n()
    const { getUid, avatar, username, onLogout, vipLevel } = useUserCommon()

    const handleClose = () => {
      props.onClose?.()
    }

    const handleLogout = () => {
      onLogout()
      handleClose()
    }

    return () => (
      <>
        <SizedBox height={16} />
        <div class="user-wrap">
          <div class="user">
            <img class="avatar" src={avatar.value} alt="" />
            <div class="user-name">
              <p class="user-name-text">{username.value}</p>
              <p class="user-id">
                <span>UID:</span>
                <Uid />
                <CopyText value={getUid.value} />
              </p>
              {vipLevel.value?.isGreaterThan(0) && (
                <div class="vip-info">
                  <UserVipIcon /> VIP{vipLevel.value}
                </div>
              )}
            </div>
          </div>

          <div class="menu-list">
            <UserMenuComp onClose={handleClose} />
          </div>
        </div>
        <HocElDivider />
        {/* 退出登录 */}
        <div class="login-out">
          <ExitIcon />
          <div class="logout-btn" onClick={handleLogout}>
            {t('退出登录')}
          </div>
        </div>
      </>
    )
  },
})
